import React, { ReactElement } from 'react';
import { LatLngBoundsExpression, LatLngExpression } from 'leaflet';
// import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import useStyles from './styles';
import * as parkData from './dummy_data.json';
import MapWrapper from './components/map_wrapper';

import {
  Circle,
  CircleMarker,
  MapContainer,
  Marker,
  Polygon,
  Polyline,
  Popup,
  Rectangle,
  TileLayer,
} from 'react-leaflet';
import { Icon } from 'leaflet';

export const icon = new Icon({
  iconUrl: require('../../../assets/images/icons/marker.png'),
  iconSize: [25, 25],
});

const polyline: LatLngExpression[] | LatLngExpression[][] = [
  [51.505, -0.09],
  [51.51, -0.1],
  [51.51, -0.12],
];

const multiPolyline: LatLngExpression[] | LatLngExpression[][] = [
  [
    [51.5, -0.1],
    [51.5, -0.12],
    [51.52, -0.12],
  ],
  [
    [51.5, -0.05],
    [51.5, -0.06],
    [51.52, -0.06],
  ],
];

const polygon: LatLngExpression[] | LatLngExpression[][] = [
  [51.515, -0.09],
  [51.52, -0.1],
  [51.52, -0.12],
];

const multiPolygon: LatLngExpression[] | LatLngExpression[][] = [
  [
    [51.51, -0.12],
    [51.51, -0.13],
    [51.53, -0.13],
  ],
  [
    [51.51, -0.05],
    [51.51, -0.07],
    [51.53, -0.07],
  ],
];

const rectangle: LatLngBoundsExpression = [
  [51.49, -0.08],
  [51.5, -0.06],
];

const fillBlueOptions = { fillColor: 'blue' };
const blackOptions = { color: 'black' };
const limeOptions = { color: 'lime' };
const purpleOptions = { color: 'purple' };
const redOptions = { color: 'red' };

const center: LatLngExpression = [51.505, -0.09];

interface IProps {
  scrollWheelZoom: boolean;
  height?: number | string;
}

// it's necessary to tell variable type
// let someFeatures: GeoJSON.FeatureCollection<any> = {
//   type: 'FeatureCollection',
//   features: [
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: [0, 0]
//       },
//       properties: {}
//     }
//   ]
// };

export default function LeafletMap({
  scrollWheelZoom,
  height = '70vh',
}: IProps): ReactElement {
  const classes = useStyles();
  const position: LatLngExpression = [51.505, -0.09];

  // L.geoJSON(someFeatures,
  //   // {
  //   // filter: function(feature, layer) {
  //   //     return feature.properties.show_on_map;
  //   // }
  // }).addTo(map);

  return (
    <div className={classes.root}>
      {/* <MapContainer style={{height: '100%'}} center={position} zoom={13} scrollWheelZoom={false}>
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={position}>
          <Popup>
            A pretty CSS3 popup. <br /> Easily customizable.
          </Popup>
        </Marker>
      </MapContainer> */}
      <MapWrapper height={height}>
        <MapContainer
          zoom={13}
          scrollWheelZoom={scrollWheelZoom}
          style={{ height: '100%' }}
          center={center}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          />
          {parkData.features.map((park) => (
            <Marker
              key={park.properties.PARK_ID}
              position={[
                park.geometry.coordinates[1],
                park.geometry.coordinates[0],
              ]}
              //   icon={icon}
            >
              <Popup>
                <div>
                  <h2>{park.properties.NAME}</h2>
                  <p>{park.properties.DESCRIPTIO}</p>
                </div>
              </Popup>
            </Marker>
          ))}
          <TileLayer
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Circle center={center} pathOptions={fillBlueOptions} radius={200} />
          <CircleMarker center={center} pathOptions={redOptions} radius={20}>
            <Popup>Popup in CircleMarker</Popup>
          </CircleMarker>
          <Polyline pathOptions={limeOptions} positions={polyline} />
          <Polyline pathOptions={limeOptions} positions={multiPolyline} />
          <Polygon pathOptions={purpleOptions} positions={polygon} />
          <Polygon pathOptions={purpleOptions} positions={multiPolygon} />
          <Rectangle bounds={rectangle} pathOptions={blackOptions}>
            <Popup>
              <p>Hello !!</p>
            </Popup>
          </Rectangle>
        </MapContainer>
      </MapWrapper>
    </div>
  );
}
